<template>
  <div class="story-wrapper">
    <h2 :style="makeColor()">ノベルを閲覧する</h2>
    <template v-for="(story, idx) in widgetData.story">
      <div
        :key="idx"
        class="-story-card"
        @click="openNovel(story)"
        v-if="idx < 5">
        <div class="-story-left">
          <img class="img-card" @error="imageError(story)" :src="getBackgroundStory(story)" v-if="loadImageError(story)"/>
          <img class="img-card" :src="errorIcon(story)" v-else/>
        </div>
        <div class="-story-right">
          <p class="story-title">{{story.title}}</p>
          <div class="story-tags">
            <div v-for="(t, i) in tagsList(story.tags)" :key=i class="tag is-small is-primary -tag" v-if="t != '' && i < 3">
              {{t}}
            </div>
          </div>
          <div class="story-count">
            <p class="pv">
              <span class="mdi mdi-eye"></span>
              {{story.pv_count}}
            </p>
            <p class="fav">
              <span class="mdi mdi-heart"></span>
              {{story.gv_count}}
            </p>
          </div>
        </div>
        <a :style="makeColor()" style="position: absolute; right: 8px; top: 22px; font-size: 24px;">
          <span class="mdi mdi-chevron-right"></span>
        </a>
      </div>
    </template>
    <div class="-footer">
      <a :style="makeColor()" @click="changeView(true, false, 'story')">
        他のノベルも閲覧する
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: Object,
      required: true
    },
    widgetData: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      isImageError: []
    }
  },
  methods: {
    changeView (isDetail, isStoryView, viewType) {
      this.$emit('changeView', {
        isDetail: isDetail,
        isStoryView: isStoryView,
        viewType: viewType
      })
    },
    makeColor () {
      return {
        'color': this.color.iconBg + '!important'
      }
    },
    openNovel (story) {
      const url = '/recruits/story/' + story.company_id + '/' + story.story_id
      this.$emit('openNovel', url)
      this.changeView(false, true, null)
    },
    getBackgroundStory (story) {
      if (story.icon_data) {
        // オリジナル画像から使う
        return story.icon_data
      } else {
        // デフォルト画像から使う
        return require('@/assets/scene/' + story.icon_type + '.jpg')
      }
    },
    tagsList (tags) {
      if (tags === null) {
        return []
      } else {
        const arr = tags.split(',')
        arr.pop()
        return arr
      }
    },
    imageError (story) {
      this.isImageError.push(story.story_id)      
    },
    loadImageError (story) {
      if　(this.isImageError.indexOf(story.story_id) == -1){
        return true
      } else {
        return false
      }
    },
    errorIcon (story) {
      return require('@/assets/scene/' + story.icon_type + '.jpg')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
// ストーリー
.story-wrapper {
  border-radius: 8px;
  width: calc(100% - 24px);
  height: auto;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  margin: 8px;
  padding: 8px 0px;
  h2 {
    width: 100%;
    padding: 8px 16px;
    text-align: left;
    font-weight: 600;
    font-size: 16px;
  }
  .-story-card {
    position: relative;
    border-radius: 8px;
    height: auto;
    width: calc(100% - 24px);
    margin: 8px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    cursor: pointer;
    transition: 0.5s;
    .-story-left {
      width: 142px;
      display: flex;
      align-items: center;
      justify-content: center;
      .img-card {
        width: 128px;
        height: 80px;
        padding: 12px;
        border-radius: 16px;
        object-fit: cover;
      }
    }
    .-story-right {
      width: calc(100% - 142px);
      padding: 8px;
      text-align: left;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      margin-left: -16px;
      .story-title {
        font-weight: 600;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .story-count {
        font-size: 12px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 4px;
        .pv {
          margin-right: 8px;
        }
        .fav {
          color: red;
        }
      }
      .story-tags {
        text-align: left;
        overflow: hidden;
        .-tag {
          margin: 2px;
        }
      }
    }
  }
  .-story-card:hover {
    transform: scale(1.025);
  }
  .-footer {
    border-top: solid thin #ccc;
    padding: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ChatWidgetDialog/organisms/StoryContent.vue